import {RECEIVE_SERVICELEVEL_DATA} from "../actions/serviceLevelDataActions";

const initialState = {
  items: []
};

export default function (state = initialState, action) {

  switch (action.type) {
    case RECEIVE_SERVICELEVEL_DATA:
      return {
        ...state,
        items: action.payload
      };
    default:
      return state;
  }
};


// WEBPACK FOOTER //
// ./src/reducers/serviceLevelReducer.js